import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getDestinationsSgw(actions) {

  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/sgw-destinations?page=" + actions.page
        : apiUrl + "/sgw-destinations" + actions.query;



    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }
    const response = yield call(apiCall, "GET", url, requestOptions);

    let responseStatus = "warning";

    if (response.results) {
      responseStatus = "success";
    } else {
      responseStatus = "error";
    }

    yield put({
      type: "LIST_DESTINATIONS_SGW_RESPONSE_GET",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "LIST_DESTINATIONS_SGW_RESPONSE_GET",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}


function* getDestinations(actions) {

  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.shortCode === null
        ? apiUrl + "/opa-destinations?page=" + actions.page
        : apiUrl + "/opa-destinations?include=images&short_code=" + actions.shortCode;



    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }
    const response = yield call(apiCall, "GET", url, requestOptions);
    let responseStatus = "warning";

    if (response.records) {
      responseStatus = "success";
    } else {
      responseStatus = "error";
    }

    yield put({
      type: "LIST_DESTINATIONS_RESPONSE_GET",
      value: {
        ...response.records,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "LIST_DESTINATIONS_RESPONSE_GET",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}




function* addDestination(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-destination";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "DESTINATION_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "DESTINATION_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}
function* updateDestination(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };

    let url = `${apiUrl}/opa-destination/${actions.uuid}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "DESTINATION_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "DESTINATION_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteDestination(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-destination/" + actions.uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "DESTINATION_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "DESTINATION_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}


export function* getDestinationsSgwSaga() {
  yield takeEvery("GET_DESTINATIONS_SGW", getDestinationsSgw);
}

export function* getDestinationsSaga() {
  yield takeEvery("GET_DESTINATIONS", getDestinations);
}

export function* deleteDestinationSaga() {
  yield takeEvery("DELETE_DESTINATION", deleteDestination);
}

export function* addDestinationSaga() {
  yield takeEvery("ADD_DESTINATION", addDestination);
}

export function* updateDestinationSaga() {
  yield takeEvery("UPDATE_DESTINATION", updateDestination);
}



const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};